import Expert from "./components/Expert";
import Header from "./components/Header";
import NewsLetter from "./components/NewsLetter";
import Cards from "./components/Cards";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <Expert />
      <NewsLetter />
      <Cards />
      <Footer />
    </>
  );
}

export default App;
